import PayRemainingPayment from './PayRemainingPayment';

import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { withRouter } from 'react-router-dom';

import {
  errorSel,
  successSel,
  invoicesActions,
  selectedInvoicesSel
} from 'src/store/modules/invoices';
import { IInvoiceCreditPayment } from 'src/services/invoice/InvoiceService';
import {
  creditCardActions,
  savedCreditCardsSel,
  selectedCardSel,
  creditCardErrorSel,
  creditCardSuccessSel,
  creditCardIsPendingSel
} from 'src/store/modules/creditcard';
import CreditCardModel from 'src/model/creditCard.model';
import { userDataSel, userActions, accountsSel } from 'src/store/modules/user';
import {
  accountViewActions,
  creditCardSel
} from 'src/store/modules/accountview';

const mapStateToProps = (state: IInitialState) => ({
  errorPayment: errorSel(state),
  successPayment: successSel(state),
  savedCreditCards: savedCreditCardsSel(state),
  selectedCreditCard: selectedCardSel(state),
  creditCardError: creditCardErrorSel(state),
  creditCardSuccess: creditCardSuccessSel(state),
  creditCardIsPending: creditCardIsPendingSel(state),
  userData: userDataSel(state),
  selectedInvoices: selectedInvoicesSel(state),
  accounts: accountsSel(state),
  creditCardStatus: creditCardSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  payInvoicesByCredit: (
    invoicePayments: IInvoiceCreditPayment[],
    signature: string
  ) => {
    dispatch(invoicesActions.payInvoicesByCredit(invoicePayments, signature));
  },
  clearAlert: () => {
    dispatch(invoicesActions.setError(''));
    dispatch(invoicesActions.setSuccess());
    dispatch(creditCardActions.setError());
    dispatch(creditCardActions.setSuccess());
  },
  getSavedCards: () => {
    dispatch(creditCardActions.getSavedCards());
  },
  getUserDetails: () => {
    dispatch(userActions.getUserDetails());
  },
  onSelectCreditCard: (creditCard: CreditCardModel) => {
    dispatch(creditCardActions.setSelectedCard(creditCard));
  },
  payInvoicesByCreditCard: (
    invoicePayments: IInvoiceCreditPayment[],
    cardId: string,
    props: any
  ) => {
    dispatch(creditCardActions.payInvoices(invoicePayments, cardId, props));
  },
  getAccounts: (search: string, page?: number, size?: number) =>
    dispatch(userActions.searchUserAccounts(search, page, size)),
  getCreditCardStatus: () => {
    dispatch(accountViewActions.getCreditCardStatus());
  }
});

export const pureDesktopComponent = PayRemainingPayment;
export const PaymentDesktop: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(PayRemainingPayment)));
